import { api } from '@api'
import type { InsertPoentialHighQuality } from '@hvf/contracts'

export const createPotentialHighQualityPost = async (
	potentialHighQuality: InsertPoentialHighQuality,
) => {
	const { data, error } = await api()
		.from('potential_high_quality')
		.insert(potentialHighQuality)

	if (error) {
		// handle error
	}

	return data
}

// New: Call the database execution transaction
export const confirmPotentialHighQualityRpc = async (setupId: string) => {
	const { data, error } = await api()
		.rpc('confirm_phq', { target_setup_id: setupId })
		.single()

	if (error) {
		console.error('❌ Failed to confirm PHQ via RPC:', error.message)
	}

	return data
}

export async function handleGetPotentialHighQuality(userId: string) {
	const client = api()

	// Step 1: Fetch user's potential_high_quality with setup.symbol
	const { data: potentialHighQuality, error: phqError } = await client
		.from('potential_high_quality')
		.select(`
			*,
			setup:setup_id (
				id,
				symbol,
        title
			)
		`)

	if (phqError) throw phqError

	const setupIds = [...new Set(potentialHighQuality.map((phq) => phq.setup_id))]

	if (setupIds.length === 0) return []

	// Step 2: Fetch taken_setups for those setup_ids
	const { data: takenSetups, error: tsError } = await client
		.from('taken_setups')
		.select('setup_id')
		.eq('user_id', userId)
		.in('setup_id', setupIds)

	if (tsError) throw tsError

	const takenSetupIds = new Set(takenSetups.map((ts) => ts.setup_id))

	// Step 3: Filter out rows where user has already scored that setup
	const unscored = potentialHighQuality.filter(
		(phq) => !takenSetupIds.has(phq.setup_id),
	)

	return unscored
}
